import { createContext, useContext, useState, type ReactNode } from "react";

import { noop } from "lodash";

import type { IWebsitesFavicons } from "app/services/sitesService/types";

type ActivationProjectContextValue = {
    favicons: IWebsitesFavicons;
    onFaviconsSet: (favicons: IWebsitesFavicons) => void;
};

const initialState: ActivationProjectContextValue = {
    favicons: {},
    onFaviconsSet: noop,
};

const ActivationProjectContext = createContext<ActivationProjectContextValue>(initialState);

export const ActivationProjectContextProvider = ({ children }: { children: ReactNode }) => {
    const [favicons, setFavicons] = useState<IWebsitesFavicons>({});

    const onFaviconsSet = (nextFavicons: IWebsitesFavicons) => {
        setFavicons((prev) => ({ ...prev, ...nextFavicons }));
    };

    return (
        <ActivationProjectContext.Provider value={{ favicons, onFaviconsSet }}>
            {children}
        </ActivationProjectContext.Provider>
    );
};

export const useActivationProjectContext = () => {
    const context = useContext(ActivationProjectContext);

    if (context === undefined) {
        throw new Error("useActivationHomeContext must be used within a ActivationHomeContextProvider");
    }

    return context;
};
